module.exports = "<div class=\"panel panelWrapper\" style=\"margin-bottom:0px;\">\r\n    <div [class]=\"visible ? 'expandedPanel': 'collpasedPanel'\" (click)=\"visible = !visible\">\r\n        <ng-content select=\"[panel-header]\"></ng-content>\r\n    </div>\r\n    <div class=\"panel-body\" *ngIf=\"visible && hasBody\">\r\n        <ng-content select=\"[panel-body]\"></ng-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/panel/panel.component.html
// module id = ../../../../../app/shared/components/panel/panel.component.html
// module chunks = main